



























































































import Vue from "vue";
import SkillRate from "@/components/SkillRate.vue";
import workExperienceData from "@/data/WorkExperienceData.ts";
import WorkExperience from "@/components/WorkExperience.vue";

export default Vue.extend({
  name: "Resume",
  components: {
    SkillRate,
    WorkExperience,
  },
  data() {
    return {
      workExperienceData,
    };
  },
});
